/**
 * Health component - tracks entity health
 */

export interface HealthComponent {
  current: number;
  max: number;
}

export function createHealth(max: number): HealthComponent {
  return { current: max, max };
}
